export const CommonPageTypes = {
  NOT_FOUND: "PAGE_NOT_FOUND",
};
